import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

/**
 * Filters, sorting and paging live in the URL, so a refresh keeps them and a
 * filtered list can be shared as a link. Changing anything but the offset
 * starts again from the first page.
 */
export function useListParams(defaults: Record<string, string> = {}) {
  const [search, setSearch] = useSearchParams()

  const params: Record<string, string> = { ...defaults }
  search.forEach((value, key) => {
    params[key] = value
  })

  const set = useCallback(
    (patch: Record<string, string | undefined>) => {
      setSearch(
        (prev) => {
          const next = new URLSearchParams(prev)
          for (const [key, value] of Object.entries(patch)) {
            if (value === undefined || value === '' || value === defaults[key]) next.delete(key)
            else next.set(key, value)
          }
          // opening a drawer or turning the page keeps the page; anything else starts over
          if (!Object.keys(patch).every((k) => k === 'offset' || k === 'team' || k === 'user')) next.delete('offset')
          return next
        },
        { replace: true },
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSearch, JSON.stringify(defaults)],
  )

  return { params, set }
}
